import React from 'react';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';

import { ConfigureForm } from './ConfigureForm';
import { transformOfferToInitialValues } from './utils/configureFormInitialValues';
import { getConfigureFormOperations } from './utils/configureFormOperations';

import { ConfigureFormInitialValues, ConfigureFormValues } from '../../types';

export const BillboardConfigureFormContainer: React.FC<FormContainerProps> = (props) => {
  const configureProps = useGetConfigureFormProps<ConfigureFormValues, ConfigureFormInitialValues>(
    props,
    transformOfferToInitialValues,
    getConfigureFormOperations,
  );

  return <ConfigureForm {...configureProps} />;
};
